import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import { CheckSquare, DashCircle, Search, X } from "react-bootstrap-icons";
import { useForm } from 'react-hook-form';
import Loader from "react-loader-spinner";

import { searchAllAccountLevel3ForModal } from '../../Accounting/store/api/DocumentsAPI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalAccountLevel3 = (props) => {
    const frmSearchAccounts = useRef();
    const resultTable = useRef();
    const searchData = useRef({ accountName: "", accountCode: "" });
    const inputAccountName = useRef();
    const currentRowIndex = useRef(0);
    const { handleSubmit } = useForm();
    const [error, setError] = useState(null);
    const { setAccLevel3Popup, popData } = props;
    const { setAccData, show, value, parentID, parentHardCode, hasHardCode } = popData;
    const [resultList, onGetData] = useState([]);
    const handleModal = () => {
        currentRowIndex.current = 0;
        if (setAccData) {
            setAccData(null);
        }
        setAccLevel3Popup({ show: false });
    }
    function search() {
        currentRowIndex.current = 0;
        searchAllAccountLevel3ForModal(searchData.current.accountName, searchData.current.accountCode, 100, parentID, parentHardCode, hasHardCode, onGetData);
    }
    function select(row) {
        if (!row) {
            let err = null;
            if (currentRowIndex.current < 1) {
                err = "ردیفی انتخاب نشده است";
            }
            setError(err);
            if (err) {
                return;
            }
            const item = resultList[currentRowIndex.current - 1];
            currentRowIndex.current = 0;
            if (setAccData) {
                setAccData(item);
            }
        }
        else {
            if (setAccData) {
                setAccData(row);
            }
        }
        setAccLevel3Popup({ show: false });
    }
    function tableKeyDown(e) {
        if (!e.target || (e.target.form !== frmSearchAccounts.current && e.target.firstChild?.id !== "ModalAccLevel3")) {
            return;
        }
        if (!popData.show) {
            return;
        }
        if (e.keyCode === 32) {
            select();
        }
        if (e.keyCode === 27) {
            handleModal();
        }
        else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            if (resultTable.current.rows.length > 0) {
                if (e.key === "ArrowDown" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    currentRowIndex.current = 0;
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current <= 1) {
                    currentRowIndex.current = resultTable.current.rows.length;
                }
                if (e.key === "ArrowDown") {
                    currentRowIndex.current++;
                }
                else {
                    currentRowIndex.current--;
                }
                if (e.key === "ArrowDown" && currentRowIndex.current > 1) {
                    resultTable.current.rows[currentRowIndex.current - 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowDown" && currentRowIndex.current === 1) {
                    resultTable.current.rows[resultTable.current.rows.length - 1].className = "resultTableRow";
                }
                if (e.key === "ArrowUp" && currentRowIndex.current < resultTable.current.rows.length - 1) {
                    resultTable.current.rows[currentRowIndex.current + 1].className = "resultTableRow";
                }
                else if (e.key === "ArrowUp" && currentRowIndex.current === resultTable.current.rows.length - 1) {
                    resultTable.current.rows[1].className = "resultTableRow";
                }
                resultTable.current.rows[currentRowIndex.current].className = "selectedResultTableRow";
            }
        }
    }
    function rowClick(key) {
        if (currentRowIndex.current !== 0) {
            resultTable.current.rows[currentRowIndex.current].className = "resultTableRow";
        }
        currentRowIndex.current = key;
        resultTable.current.rows[key].className = "selectedResultTableRow";

    }

    useEffect(() => {
        if (inputAccountName.current) {
            if (value && value !== ' ' && inputAccountName.current.value === '') {
                inputAccountName.current.value = value;
                searchData.current.Name = value;
            }
            inputAccountName.current.focus();
        }
        document.addEventListener('keydown', tableKeyDown);

        return () => {
            document.removeEventListener('keydown', tableKeyDown);
        };
    }, [value, resultList])
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }} id="ModalAccLevel3">
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faCheckSquare} size='lg' />&nbsp;
                    انتخاب حساب
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={handleModal} size='lg' /></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <form onSubmit={handleSubmit(search)} ref={frmSearchAccounts} className="rowBorder" style={{ paddingRight: "5px" }}>
                    <div className="row">
                        {error && <small className='errors' style={{ textAlign: "center" }}>{error}</small>}

                        <div className="form-group col-md-5">
                            <input type="text" placeholder="کد حساب" className="form-control" onChange={e => searchData.current.accountCode = e.target.value} />
                        </div>
                        <div className="form-group col-md-5">
                            <input ref={inputAccountName} type="text" placeholder="نام حساب" className="form-control"
                                onChange={e => searchData.current.accountName = e.target.value} />
                        </div>

                    </div>
                    <Button variant='secondary' className='mt-2 group-Btn' type='submit'><Search />&nbsp;جستجوی حساب</Button>
                </form>
                <div className='scThin' style={{ maxHeight: "350px", overflow: "auto" }}>
                    <Table className="mt-0 mb-0" ref={resultTable} >
                        <thead>
                            <tr style={{ padding: "0" }}>
                                <th style={{ top: 0, position: "sticky", backgroundColor: "#b6b6b6" }}>کد حساب</th>
                                <th style={{ top: 0, position: "sticky", backgroundColor: "#b6b6b6" }}>نام حساب</th>
                            </tr>
                        </thead>
                        <tbody>
                            {resultList === "PENDING" &&
                                <tr>
                                    <td colSpan={3} style={{ textAlign: "center" }}>
                                        <Loader type="BallTriangle" color="#bb1370" width="25" height="25" />
                                    </td>
                                </tr>
                            }
                            {resultList && !resultList.Error && Array.isArray(resultList) && resultList.map((item, i) => {
                                return (
                                    <tr className='resultTableRow' key={i} onClick={() => rowClick(i + 1)} onDoubleClick={() => select(item)}>
                                        <td>{item.AccountLevelOCode + "/" + item.AccountLevelOneCode + "/" + item.AccountLevelTwoCode + "/" + item.AccountLevelThreeCode}</td>
                                        <td>{item.AccountName}</td>
                                    </tr>)
                            })
                            }
                        </tbody>
                    </Table>
                </div>
                <div>
                    <Button className='group-Btn' onClick={() => select()}><CheckSquare size={16} />&nbsp;انتخاب حساب</Button>
                    <Button variant='danger' className='group-Btn' onClick={handleModal} ><DashCircle size={16} />&nbsp;انصراف</Button>
                </div>
            </Modal.Body>
        </Modal >
    )
}
export default ModalAccountLevel3;